import React from 'react';
import { authRoutes, publicRoutes } from './router.link';
import { Route, Routes } from 'react-router-dom';
import AuthFeature from '../authFeature';
import Feature from '../feature';

const AllRoutes = () => {
  return (
    <>
      <Routes>
        <Route element={<Feature />}>
          {publicRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
        <Route element={<AuthFeature />}>
          {authRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
      </Routes>
    </>
  );
};
export default AllRoutes;
